module.exports = __webpack_public_path__ + "static/media/waze-icon.3018d5fa.svg";